// extracted by mini-css-extract-plugin
export default {"flags":"styles_flags__ENg4B","flag":"styles_flag__esuI0"};